// extracted by mini-css-extract-plugin
export default {"variantsWrapper":"WoSOH","prices":"gdnI_","price":"ODJSF"};